import type { ReactNode } from 'react';

import { AccessContext } from './AccessContext';
import type { AccessContextValue } from './AccessContext';
import type { MeAccess } from './types';

const NO_ACCESS: MeAccess = {
  roleKey: null,
  adminGrant: null,
  clusterId: null,
  isStaff: false,
  permissionsVersion: 0,
  landing: null,
  adminKeys: new Set(),
  baseKeys: new Set(),
  plantIds: [],
  plants: new Map(),
};

const PRINT_ACCESS: AccessContextValue = { me: NO_ACCESS, policy: 'enforce' };

export const PrintAccessProvider = ({ children }: { readonly children: ReactNode }) => (
  <AccessContext.Provider value={PRINT_ACCESS}>{children}</AccessContext.Provider>
);
